/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum CpotPainScaleAliases {
  BODY_MOVIMENTS_RG = 'body-moviments-rg',
  BODY_MOVIMENTS_TEXT = 'body-moviments-text',
  CPOT_BODY_MOVIMENTS_FIELD = 'cpot-body-moviments-field',
  CPOT_BODY_MOVIMENTS_SCALE_FORM = 'cpot-body-moviments-scale-form',
  CPOT_EXTUBATED_PATIENT_FIELD = 'cpot-extubated-patient-field',
  CPOT_EXTUBETED_PETIENT_SCALE_FORM = 'cpot-extubeted-petient-scale-form',
  CPOT_FACIAL_EXPRESSION_FIELD = 'cpot-facial-expression-field',
  CPOT_MUSCLE_SCALE_FORM = 'cpot-muscle-scale-form',
  CPOT_MUSCLE_TENSION_FIELD = 'cpot-muscle-tension-field',
  CPOT_PAIN_SCALE_LAYOUT = 'cpot-pain-scale-layout',
  CPOT_REFERENCE_LINK = 'cpot-reference-link',
  CPOT_REFERENCE_LINK_PANEL = 'cpot-reference-link-panel',
  CPOT_REFERENCE_PANEL = 'cpot-reference-panel',
  CPOT_RESPIRATOR_SUITABILITY_FIELD = 'cpot-respirator-suitability-field',
  CPOT_RESPIRATOR_SUITABILITY_SCALE_FORM = 'cpot-respirator-suitability-scale-form',
  CPOT_SCALE_FORM = 'cpot-scale-form',
  EXTUBATED_PATIENTS_RG = 'extubated-patients-rg',
  EXTUBETED_PATIENT_TEXT = 'extubeted-patient-text',
  FACIAL_EXPRESSION_RG = 'facial-expression-rg',
  FACIAL_EXPRESSION_TEXT = 'facial-expression-text',
  MODAL_PAIN_SCALE_REFERENCE = 'modal-pain-scale-reference',
  MUSCLE_TENSION_RG = 'muscle-tension-rg',
  MUSCLE_TENSION_TEXT = 'muscle-tension-text',
  PAIN_SCALE_CONTENT_PANEL = 'pain-scale-content-panel',
  PAIN_SCALE_CONTEXTUAL_BAR = 'pain-scale-contextual-bar',
  RESPIRATOR_SUITABILITY_RG = 'respirator-suitability-rg',
  RESPIRATOR_SUITABILITY_TEXT = 'respirator-suitability-text',
  TEXT_CPOT_PAIN_SCALE_REFERENCE = 'text-cpot-pain-scale-reference',
}
export { CpotPainScaleAliases };
